import { Directive } from '@angular/core';
import { ValidatorFn, AbstractControl, FormGroup } from '@angular/forms';
import { ErrorType } from 'src/app/models';

@Directive({
  selector: '[appChangePasswordForm]'
})
export class ChangePasswordFormDirective {
  constructor() { }

}

export function minimumLengthRequired(minLength: string): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (control.value === '') { return null; }
    const re = '^.{' + minLength + ',}$';
    const lowerCasePattern: RegExp = new RegExp(re, '');
    const forbidden = !lowerCasePattern.test(control.value);
    // console.log('minimum length of ' + minLength + ' required: ' + forbidden);
    return forbidden ? {[ErrorType._4401.code]: ErrorType._4401.message} : null;
  };
}

export function upperCaseRequired(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (control.value === '') { return null; }
    const upperCasePattern: RegExp = /.*[A-Z]/;
    const forbidden = !upperCasePattern.test(control.value);
    // console.log('upper case required: ' + forbidden);
    return forbidden ? {[ErrorType._4402.code]: ErrorType._4402.message} : null;
  };
}

export function lowerCaseRequired(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (control.value === '') { return null; }
    const lowerCasePattern: RegExp = /.*[a-z]/;
    const forbidden = !lowerCasePattern.test(control.value);
    // console.log('lower case required: ' + forbidden);
    return forbidden ? {[ErrorType._4403.code]: ErrorType._4403.message} : null;
  };
}

export function digitRequired(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (control.value === '') { return null; }
    const digitPattern: RegExp = /.*\d/;
    const forbidden = !digitPattern.test(control.value);
    // console.log('digit required: ' + forbidden);
    return forbidden ? {[ErrorType._4404.code]: ErrorType._4404.message} : null;
  };
}

export function forbiddenNameValidator(name: string): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (control.value === '' || name === undefined || name === '.' || name === '') { return null; }
    const nameRe: RegExp = new RegExp(name, 'i');
    const forbidden = nameRe.test(control.value);
    // console.log('name: ' + name + ' validator: ' + forbidden);
    return forbidden ? {[ErrorType._4405.code]: ErrorType._4405.message} : null;
  };
}

export function equalPasswordValidator(): ValidatorFn {
  return (formGroup: FormGroup): {[key: string]: any} | null => {
    const newPasswordInput = 'newPassword';
    const confirmPasswordInput = 'confirmPassword';
    const newPassword = formGroup.controls[newPasswordInput].value;
    const confirmPassword = formGroup.controls[confirmPasswordInput].value;
    if (newPassword === '' || confirmPassword === '') { return null; }
    // console.log('epv: "' + newPassword + '":"' + confirmPassword + '"');
    const forbidden = (newPassword !== confirmPassword);
    // console.log('not equal password: ' + forbidden);
    if (forbidden) { formGroup.controls[confirmPasswordInput].setErrors({[ErrorType._4408.code]: ErrorType._4408.message}); }
    else { formGroup.controls[confirmPasswordInput].setErrors(null); }
    return forbidden ? {[ErrorType._4408.code]: ErrorType._4408.message} : null;
  };
}
